import {
  ArrowLeft2,
  Call,
  CloseCircle,
  // Edit,
  Location,
  // Trash,
} from "iconsax-react";
import React, { useEffect, useState } from "react";
import { Btn, SuccessComp } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import mail from "../../assets/mail.png";
import Overlay from "../../components/overlay/Overlay";
import DeletePopup from "../../utils/DeletePopup";
import { AxiosAuthGet, AxiosAuthPost } from "../../api/api";
import Loading from "../../components/ui/Loading";

const DevCusView = () => {
  const customer = JSON.parse(localStorage.getItem("singleCus"));
  const url = `developer/customers/${customer?.id}/`;
  const transUrl = `developer/customers/${customer?.id}/transactions/`;
  // console.log(customer);
  const navigate = useNavigate();
  const [singleTrans, setSingleTrans] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [isCusLoad, setIsCusLoad] = useState(false);
  const [isTransLoad, setIsTransLoad] = useState(false);
  // const [isDelLoad, setIsDelLoad] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [singleCus, setSingleCus] = useState();

  const goBack = () => {
    navigate(-1);
  };

  const getSingleCus = () => {
    setIsCusLoad(true);
    AxiosAuthGet(url)
      .then((res) => {
        // console.log(res);
        setSingleCus(res?.data);
        setIsCusLoad(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsCusLoad(false);
      });
  };


  // const delFunc = () => {

  // }

  const clickTrans = (item) => {
    setSingleTrans(item);
  };
  const closeTrans = () => {
    setSingleTrans(null);
  };

  // const clickDelete = () => {
  //   setIsDelete(!isDelete);
  // };

  useEffect(() => {
    getSingleCus();
    // eslint-disable-next-line
  }, []);

  const dataSet = {
    transactionId: singleTrans?.id,
    status: "Paid",
  };

  const postTrans = () => {
    setIsTransLoad(true);
    AxiosAuthPost(transUrl, dataSet)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res.message);
        setTimeout(() => {
          setSingleTrans(null);
          setSuccessMsg("");
          window.location.reload();
        }, 2000);
        setIsTransLoad(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsTransLoad(false);
      });
  };

  return (
    <div style={{ position: "relative" }}>
      {
        <DeletePopup
          isDelete={isDelete}
          setIsDelete={setIsDelete}
          text={customer?.name}
        />
      }
      <SuccessComp message={successMsg} />
      {singleTrans !== null && <Overlay />}
      {singleTrans !== null && (
        <div className="t_det">
          <div className="t_det_icon">
            <CloseCircle
              size={24}
              color="#344054"
              onClick={closeTrans}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="t_det_head">
            <h3>Transaction Details</h3>
            <h6>View and manage transaction {singleTrans?.transactionReference}</h6>
          </div>
          <div className="flex_t">
            <div className="info_text">
              <h5>Transaction ID</h5>
              <p>{singleTrans?.transactionReference}</p>
            </div>
            <div className="info_text">
              <h5>Amount</h5>
              <h6>{`#${singleTrans?.amount?.toLocaleString()}`}</h6>
            </div>
          </div>
          <div className="flex_t">
            <div className="info_text">
              <h5>Due Date</h5>
              <p>{singleTrans?.dueDate?.split("T")[0]}</p>
            </div>
            <div className="info_text">
              <h5>Status</h5>
              <p>{singleTrans?.status}</p>
            </div>
          </div>
          <div className="flex_t">
            <div className="info_text">
              <h5>Paid Date</h5>
              <p>{singleTrans?.paidDate?.split("T")[0]}</p>
            </div>
          </div>
          <div className="det_btn">
            <Btn
              btnText={"Close"}
              btnClass={"btn_dark_out_thin f_w_600"}
              btnClick={closeTrans}
            />
            {singleTrans?.status !== "Paid" && <Btn
              btnText={"Mark as Paid"}
              btnClass={"btn_green_thin f_w_600"}
              btnClick={postTrans}
              loading={isTransLoad}
            />}
          </div>
        </div>
      )}

      <div className="cus_view_head">
        <div className="c_v_left" onClick={goBack}>
          <ArrowLeft2 color="#011F1B" size={16} />
          <div className="c_v_l_text">
            <p>Customer Details</p>
            <h4 style={{textTransform: 'capitalize'}}>{singleCus?.name}</h4>
          </div>
        </div>
        <div className="c_v_right">
          {/* <Btn
            btnClick={() => {}}
            btnText={"Edit Customer"}
            leftIcon={<Edit size="24" color="#737475" />}
            btnClass={"btn_gray"}
          /> */}
          {/* <Btn
            btnClick={clickDelete}
            btnText={"Delete"}
            leftIcon={<Trash size="24" color="#FF0000" />}
            btnClass={"btn_error"}
          /> */}
        </div>
      </div>
      {isCusLoad && <Loading />}
      {!isCusLoad && (
        <div className="estates_houses" style={{ margin: 0 }}>
          <div className="add_prop_inp">
            <h3>Contact Information</h3>
            <div className="inf_cont">
              <div className="ic_dv">
                <Call color="#848484" size={20} />
              </div>
              <div className="info_text">
                <h5>Phone</h5>
                <p>{singleCus?.phoneNumber}</p>
              </div>
            </div>
            <div className="inf_cont">
              <div className="ic_dv">
                <img src={mail} alt="email" />
              </div>
              <div className="info_text">
                <h5>Email</h5>
                <p style={{ textTransform: "lowercase" }}>{singleCus?.email}</p>
              </div>
            </div>
            <div className="inf_cont">
              <div className="ic_dv">
                <Location color="#848484" size={20} />
              </div>
              <div className="info_text">
                <h5>Address</h5>
                <p>{singleCus?.address}</p>
              </div>
            </div>
          </div>
          <div className="add_prop_inp">
            <h3>Property Information</h3>
            <div className="p_info_cont">
              <div className="info_text">
                <h5>Property</h5>
                <p>{singleCus?.property?.name}</p>
              </div>
              <div className="info_text">
                <h5>Estate</h5>
                <p>{singleCus?.estate?.name}</p>
              </div>
              <div className="info_text">
                <h5>Type</h5>
                <h4>{singleCus?.property?.propertyType}</h4>
              </div>
              <div className="info_text">
                <h5>Price</h5>
                <h6>{`#${singleCus?.totalAmount?.toLocaleString()}`}</h6>
              </div>
              <div className="info_text">
                <h5>Payment Type</h5>
                <h3>{singleCus?.paymentType}</h3>
              </div>
            </div>
          </div>
          <div className="add_prop_inp" style={{ padding: 0 }}>
            <div className="t_cont">
              <h3>Transactions</h3>
              <h6>Payment history for this customer</h6>
            </div>
            <div className="t_wrapper">
              <table className="transactionsTable">
                <thead>
                  <tr>
                    <th>Transaction ID</th>
                    <th>Amount</th>
                    <th>Due Date</th>
                    <th>Paid Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {singleCus?.transactions.map((item, index) => (
                    <tr key={index}>
                      <td>{item?.transactionReference}</td>
                      <td>{`#${item?.amount?.toLocaleString()}`}</td>
                      <td>{item?.dueDate?.split("T")[0]}</td>
                      <td>{item?.paidDate?.split("T")[0] || "—"}</td>
                      <td>
                        <span
                          className={`statusBadge ${
                            item.status === "Paid" ? "paid" : "unpaid"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
                      <td
                        className="viewAction"
                        onClick={() => clickTrans(item)}
                      >
                        View
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DevCusView;
